import React, { useState, useEffect } from "react";
import CardButtonGroup from "../../components/plot_engagement/ActivityCard";

// component
import HarvestingPopup from "./Popup/HarvestingPopup";
import PreparationIconWithTick from "./IconStatus";

const HarvestingActivityCard = ({ status, updateStatus, t }) => {
  const [popupType, setPopupType] = useState(null);

  const queryParams = new URLSearchParams(location.search);
  const openPopup = queryParams.get("openPopup");

  const setOpenPopupType = () => {
    if (openPopup) {
      setPopupType(openPopup);
    }
  };

  const handleButtonClick = (type) => {
    setPopupType(type);
  };

  useEffect(() => {
    setOpenPopupType();
  }, [openPopup]);

  const getActivityStatus = (activity) =>
    status && Array.isArray(status) && status[0]?.[activity];
  const HarvestingActivityButton = [
    {
      label: t("Harvesting"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("harvesting")}
          activityType="harvesting"
        />
      ),
      onClick: () => handleButtonClick("Harvesting"),
    },
  ];
  const closePopup = () => {
    setPopupType(null);
    updateStatus();
  };
  return (
    <div>
      <CardButtonGroup buttons={HarvestingActivityButton} t={t} />
      {popupType === "Harvesting" && (
        <HarvestingPopup onClose={closePopup} t={t} />
      )}
    </div>
  );
};

export default HarvestingActivityCard;
